/**
 * AnimatedBackground Component
 * 
 * Provides a professional gaming-themed animated background with:
 * - Gradient mesh movements
 * - Floating particles (large ambient effects)
 * - Glowing stars (twinkling particles)
 * - Energy lines (vertical flowing lines)
 * - Charging pulse effects
 * - Floating game particles
 * - Glow trails
 * 
 * Designed specifically for gaming recharge/charging site
 * Respects user's prefers-reduced-motion preference
 */

export function AnimatedBackground() {
  return (
    <div className="animated-background">
      {/* Large floating particles for ambient background */}
      <div className="floating-particle floating-particle-1"></div>
      <div className="floating-particle floating-particle-2"></div>
      <div className="floating-particle floating-particle-3"></div>
      <div className="floating-particle floating-particle-4"></div>
      
      {/* Glowing stars - twinkling effect */}
      <div className="game-star game-star-1"></div>
      <div className="game-star game-star-2"></div>
      <div className="game-star game-star-3"></div>
      <div className="game-star game-star-4"></div>
      <div className="game-star game-star-5"></div>
      <div className="game-star game-star-6"></div>
      <div className="game-star game-star-7"></div>
      <div className="game-star game-star-8"></div>
      <div className="game-star game-star-9"></div>
      <div className="game-star game-star-10"></div>
      
      {/* Energy lines - vertical flowing lines */}
      <div className="energy-line energy-line-1"></div>
      <div className="energy-line energy-line-2"></div>
      <div className="energy-line energy-line-3"></div>
      <div className="energy-line energy-line-4"></div>
      <div className="energy-line energy-line-5"></div>
      <div className="energy-line energy-line-6"></div>
      
      {/* Charging pulse effects */}
      <div className="charge-pulse charge-pulse-1"></div>
      <div className="charge-pulse charge-pulse-2"></div>
      <div className="charge-pulse charge-pulse-3"></div>
      
      {/* Floating game particles */}
      <div className="game-particle game-particle-1"></div>
      <div className="game-particle game-particle-2"></div>
      <div className="game-particle game-particle-3"></div>
      <div className="game-particle game-particle-4"></div>
      <div className="game-particle game-particle-5"></div>
      
      {/* Glow trails */}
      <div className="glow-trail glow-trail-1"></div>
      <div className="glow-trail glow-trail-2"></div>
      <div className="glow-trail glow-trail-3"></div>
      <div className="glow-trail glow-trail-4"></div>
    </div>
  );
}

